import React from 'react';
import styled from 'styled-components';
import Mapping from './Mapping';

const TABS = [
  { label: 'O&M Manual', dropdowns: ['Unknown'] },
  { label: 'Machineries / Post Harvest Facility', dropdowns: [] },
  { label: 'Location / Map', dropdowns: [] },
  { label: 'Masterlist', dropdowns: [] },
  { label: 'FS Results', dropdowns: [] },
  { label: 'Trainings Conducted', dropdowns: ['Regular', 'Other'] },
  { label: 'IMT Contracting', dropdowns: ['O&M Subsidy', 'Remuneration']},
  { label: 'Project Fund Source', dropdowns: [] },
  { label: 'IMT Results', dropdowns: ['First Crop', 'Second Crop'] },
  { label: 'IA Officers', dropdowns: [] },
  { label: 'Program and Projects', dropdowns: [] },
  { label: 'Best Practices', dropdowns: [] }
];

const CisModal = ({ isOpen, onClose, selectedItem, onNavigate, selectedYear, sectionKey }) => {
  const [activeTab, setActiveTab] = React.useState('O&M Manual');
  const iaName = selectedItem?.ia_name || 'Unknown IA';

  const saveReturnContext = () => {
    localStorage.setItem('cisMachineriesReturn', JSON.stringify({
      selectedItem,
      selectedYear,
      sectionKey: sectionKey || 'CISBohol'
    }));
  };

console.log('Selected Year in Modal:', selectedYear);
  
  if (!isOpen) return null;

  const renderDropdown = (items) => {
  return (
    <DropdownMenu>
      {items.map((item, index) => {
        // Case: plain string item (like "LBP", "DA")
        if (typeof item === 'string') {
          return (
            <DropdownItem
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                // Customize navigation if needed:
                onNavigate?.(item);
                onClose();
              }}
            >
              {item}
            </DropdownItem>
          );
        }

        // Case: nested dropdown object (like { label: 'Linkages', dropdowns: [...] })
        if (typeof item === 'object' && item.label) {
          return (
            <DropdownSubItem key={index}>
              {item.label}
              {item.dropdowns && renderDropdown(item.dropdowns)}
            </DropdownSubItem>
          );
        }

        return null;
      })}
    </DropdownMenu>
  );
};

  return (
    <ModalOverlay>
      <ModalContent $isMapActive={activeTab === 'Location / Map'}>
        {activeTab !== 'Location / Map' ? (
          <>
            <CloseButton onClick={onClose}>×</CloseButton>
            <Title>
        {selectedItem?.ia_name || 'Unknown IA'} - ID: {selectedItem?.id || 'N/A'}
        </Title>
            <ListWrapper>
              {TABS.map((tab) => (
                <ListItem
                  key={tab.label}
                  $isActive={tab.label === activeTab}
                  onClick={() => {
                    setActiveTab(tab.label);
                    if (onNavigate) {
                      switch (tab.label) {
                        case 'O&M Manual':
                          saveReturnContext();
                          onNavigate('ImtContract');
                          onClose();
                          break;

                       case 'Machineries / Post Harvest Facility':
                          saveReturnContext();
                          onNavigate('NISmachineries', { nisId: selectedItem?.id,  iaName: selectedItem?.ia_name });
                          onClose();
                        break;

                        case 'Masterlist':
                          saveReturnContext();
                          onNavigate('NISmasterlist', { nisId: selectedItem?.id, year: selectedYear });
                          onClose();
                          break;

                        case 'FS Results':
                          saveReturnContext();
                          onNavigate('NISfsResult', { nisId: selectedItem?.id,  iaName: selectedItem?.ia_name, year: selectedYear  });
                          onClose();
                        break;

                        case 'Trainings Conducted':
                          saveReturnContext();
                          onNavigate('IATraining');
                          onClose();
                          break;

                        case 'IMT Contracting':
                          saveReturnContext();
                          onNavigate('ImtContract');
                          onClose();
                          break;

                        case 'Project Fund Source':
                          saveReturnContext();
                          onNavigate('PFS');
                          onClose();
                          break;

                        case 'IMT Results':
                          saveReturnContext();
                          onNavigate('NISimtResult', { nisId: selectedItem?.id, iaName: selectedItem?.ia_name, year: selectedYear });
                          onClose();
                          break;

                        case 'IA Officers':
                          saveReturnContext();
                          onNavigate('NISofficers', { nisId: selectedItem?.id, iaName: selectedItem?.ia_name, year: selectedYear });
                          onClose();
                          break;

                        case 'Program and Projects':
                          saveReturnContext();
                          onNavigate('Convergence');
                          onClose();
                          break;

                        case 'Best Practices':
                          saveReturnContext();
                          onNavigate('FBmasterlist');
                          onClose();
                          break;
                        default:
                          break;
                      }
                    }
                  }}
                >
                  {tab.label}
                  {tab.dropdowns.length > 0 && renderDropdown(tab.dropdowns)}

                </ListItem>
              ))}
            </ListWrapper>
          </>
        ) : (
          <>
            <MapHeader>
              <BackButton onClick={() => setActiveTab('O&M Manual')}>
                ← Back to Menu
              </BackButton>
              <MapTitle>Location Map - {selectedItem?.ia_name || 'IA Profile'}</MapTitle>
            </MapHeader>
            <Mapping
              selectedItem={selectedItem}
              onClose={onClose}
              isEmbedded={true}
            />
          </>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default CisModal;


const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  width: ${props => props.$isMapActive ? '90%' : '300px'};
  max-width: ${props => props.$isMapActive ? '1200px' : '300px'};
  height: ${props => props.$isMapActive ? '80vh' : 'auto'};
  background: #f4f4f4;
  border: 2px solid #4caf50;
  border-radius: 6px;
  padding: ${props => props.$isMapActive ? '0' : '15px 10px 20px'};
  position: relative;
  font-family: sans-serif;
`;

const CloseButton = styled.button`
  position: absolute;
  color: white;
  top: 15px;
  right: 12px;
  font-size: 18px;
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover {
    background-color:rgb(190, 219, 23);
  }

`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-left: 5px;
  color: white;
  background-color: #2e7d32;
  padding: 8px;
  border-radius: 4px;
`;

const ListWrapper = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  position: relative;
  padding: 8px 10px;
  font-size: 14px;
  background-color: ${props => props.$isActive ? '#e9f5d0' : 'white'};
  border-left: 4px solid ${props => props.$isActive ? '#aed581' : 'transparent'};
  color: #333;
  cursor: pointer;

  &:hover {
    background-color: #f1f1f1;
  }

  &:hover > div {
    display: block;
  }
`;

const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 20;
  min-width: 180px;
`;

const DropdownItem = styled.div`
  padding: 8px 12px;
  font-size: 13px;
  color: #333;

  &:hover {
    background-color: #e0f2f1;
  }
`;

const MapHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  background: linear-gradient(45deg, #2e7d32, #4caf50);
  color: white;
  border-radius: 6px 6px 0 0;
  position: relative;
  z-index: 10;
`;

const BackButton = styled.button`
  position: absolute;
  left: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 14px;
  color: white;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const MapTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  color: white;
  margin: 0;
`;

const DropdownSubItem = styled.div`
  position: relative;
  padding: 8px 12px;
  font-size: 13px;
  color: #333;
  background-color: white;

  &:hover {
    background-color: #e0f2f1;
  }

  &:hover > div {
    display: block;
  }

  > div {
    top: 0;
    left: 100%;
  }
`;
